export const WIDGET_INTRO_KEYS = {
    PLACEHOLDER: 'WIDGET_TYPE_INTRO',
};
